import { useDispatch } from "react-redux";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetConstantListResponseItem } from "../../../../models/response/constant/GetConstantListResponse";
import { storeFastFirm, storeImageViewer } from "../../../../redux/reducers/authSlice";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import React from "react";
import CustomSwitch from "../../../../components/CustomSwitch";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { GetCountryListResponseData } from "../../../../models/response/country/GetCountryListResponse";

interface Props {
    licenseHolderRef: any
    selectedLicenseHolder: CustomSingleSelectModel | undefined
    setSelectedLicenseHolder: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCounty: CustomSingleSelectModel | undefined
    setSelectedCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    documentSerialNumber: string | undefined
    setDocumentSerialNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    registrationDate: string | undefined
    setRegistrationDate: React.Dispatch<React.SetStateAction<string | undefined>>
    getBrandAndBrandDetailFromInsuranceCode: () => Promise<void>
    insuranceCode: string | undefined
    setInsuranceCode: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedVehicleBrand: CustomSingleSelectModel | undefined
    setSelectedVehicleBrand: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedVehicleBrandDetail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedVehicleBrandDetail: CustomSingleSelectModel | undefined
    chassisNumber: string | undefined
    setChassisNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    isDeprivationOfRights: boolean | undefined
    setIsDeprivationOfRights: React.Dispatch<React.SetStateAction<boolean | undefined>>
    selectedRightsOwner: CustomSingleSelectModel | undefined
    setSelectedRightsOwner: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    tckn: string | undefined
    setTckn: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedDistrict: CustomSingleSelectModel | undefined
    licenseB64: string
    setLicenseB64: React.Dispatch<React.SetStateAction<string>>
    selectedVehicleClass: CustomSingleSelectModel | undefined
    setSelectedVehicleClass: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>,
    modelYear: string | undefined
    setModelYear: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedVehicleColor: CustomSingleSelectModel | undefined
    setSelectedVehicleColor: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    engineNumber: string | undefined
    setEngineNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    pledgeStartDate: string | undefined
    setPledgeStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    pledgeEndDate: string | undefined
    setPledgeEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    setLicenseFile: React.Dispatch<React.SetStateAction<File | undefined>>
    licenseFileRef: any
    trCountry: GetCountryListResponseData | undefined
}

const LicenseHolder = ({
    licenseHolderRef,
    selectedLicenseHolder,
    setSelectedLicenseHolder,
    selectedCounty,
    setSelectedCounty,
    setSelectedDistrict,
    documentSerialNumber,
    setDocumentSerialNumber,
    registrationDate,
    setRegistrationDate,
    getBrandAndBrandDetailFromInsuranceCode,
    insuranceCode,
    setInsuranceCode,
    selectedVehicleBrand,
    setSelectedVehicleBrand,
    setSelectedVehicleBrandDetail,
    selectedVehicleBrandDetail,
    chassisNumber,
    setChassisNumber,
    isDeprivationOfRights,
    setIsDeprivationOfRights,
    selectedRightsOwner,
    setSelectedRightsOwner,
    setTckn,
    tckn,
    selectedDistrict,
    licenseB64,
    setLicenseB64,
    selectedVehicleClass,
    setSelectedVehicleClass,
    modelYear,
    setModelYear,
    selectedVehicleColor,
    setSelectedVehicleColor,
    engineNumber,
    setEngineNumber,
    handleFileRead,
    pledgeEndDate,
    pledgeStartDate,
    setPledgeEndDate,
    setPledgeStartDate,
    setLicenseFile,
    licenseFileRef,
    trCountry
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={licenseHolderRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ruhsat Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ruhsat Sahibi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedLicenseHolder}
                                            onChange={setSelectedLicenseHolder}
                                            insertable={{
                                                tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                onClick: () => {
                                                    dispatch(storeFastFirm({
                                                        companyId: selectedLicenseHolder?.value,
                                                        isSupplier: true,
                                                        onSubmit: async (response) => {
                                                            setSelectedLicenseHolder({ label: response.name, value: response.companyId })
                                                        }
                                                    }))
                                                }
                                            }}
                                            onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Verildiği İl</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCounty}
                                            onChange={(selectedObj) => {
                                                setSelectedCounty(selectedObj);
                                                setSelectedDistrict(undefined);
                                            }}
                                            insertable={{
                                                onSubmit: { code: 'COUNTY', parentConstantId: trCountry?.countryId }
                                            }}
                                            onMenuOpen={trCountry ? () => ConstantService.getConstantList('COUNTY', trCountry.countryId) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Belge Seri No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={documentSerialNumber} onChange={(e) => setDocumentSerialNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tescil Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={registrationDate} onChange={(e) => setRegistrationDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">TSB Kasko Kodu</label>
                                        <input onBlur={getBrandAndBrandDetailFromInsuranceCode} style={{ border: '1px solid #F1F1F4' }} value={insuranceCode} onChange={(e) => setInsuranceCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Marka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleBrand}
                                            onChange={(selectedObj) => {
                                                setSelectedVehicleBrand(selectedObj);

                                                if (selectedObj) {
                                                    setInsuranceCode(selectedObj.additionalValue1);
                                                }
                                                else {
                                                    setInsuranceCode('');
                                                }

                                                setSelectedVehicleBrandDetail(undefined);
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_BRAND')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Model</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleBrandDetail}
                                            onChange={(selectedObj) => {
                                                setSelectedVehicleBrandDetail(selectedObj);

                                                if (selectedObj)
                                                    setInsuranceCode(selectedVehicleBrand?.additionalValue1 + " - " + selectedObj?.additionalValue1);
                                                else
                                                    setInsuranceCode(selectedVehicleBrand?.additionalValue1);
                                            }}
                                            onMenuOpen={selectedVehicleBrand ? () => ConstantService.getConstantList('VEHICLE_BRAND_DETAIL', selectedVehicleBrand.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>


                                    <div className='mt-5'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hak Mahrumiyeti</label>

                                        <CustomSwitch isActive={isDeprivationOfRights} setIsActive={setIsDeprivationOfRights} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hak Sahibi</label>

                                        <CustomSingleSelect
                                            disabled={Helpers.isEmpty(isDeprivationOfRights) || !isDeprivationOfRights}
                                            selectedValue={selectedRightsOwner}
                                            onChange={setSelectedRightsOwner}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_RIGHT_OWNER' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_RIGHT_OWNER')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Vergi No / TC Kimlik No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={tckn} onChange={(e) => setTckn(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Verildiği İlçe</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDistrict}
                                            onChange={setSelectedDistrict}
                                            insertable={{
                                                onSubmit: selectedCounty ? { code: 'DISTRICT', parentConstantId: selectedCounty.value } : undefined
                                            }}
                                            onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Sınıfı</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleClass}
                                            onChange={setSelectedVehicleClass}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_CLASS' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_CLASS')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Model Yılı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={modelYear} onChange={(e) => setModelYear(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Rengi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicleColor}
                                            onChange={setSelectedVehicleColor}
                                            insertable={{
                                                onSubmit: { code: 'VEHICLE_COLOR' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_COLOR')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Motor No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={engineNumber} onChange={(e) => setEngineNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>


                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Şasi No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={chassisNumber} onChange={(e) => setChassisNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Rehin Başlangıç Tarihi</label>
                                        <input disabled={Helpers.isEmpty(isDeprivationOfRights) || !isDeprivationOfRights} style={{ border: '1px solid #F1F1F4' }} value={pledgeStartDate} onChange={(e) => setPledgeStartDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Rehin Bitiş Tarihi</label>
                                        <input disabled={Helpers.isEmpty(isDeprivationOfRights) || !isDeprivationOfRights} style={{ border: '1px solid #F1F1F4' }} value={pledgeEndDate} onChange={(e) => setPledgeEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Ruhsat Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([licenseB64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={licenseB64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={licenseFileRef} onChange={(e) => { setLicenseFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setLicenseB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(licenseB64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setLicenseFile(undefined); setLicenseB64(Helpers.getPlaceholder()); licenseFileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default LicenseHolder;